// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/azp/_work/43/s/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/test",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__testPage__test' */'@/pages/testPage/test'), loading: LoadingComponent}),
    "title": "test",
    "exact": true
  },
  {
    "path": "/test/bridge",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__testPage__bridge' */'@/pages/testPage/bridge'), loading: LoadingComponent}),
    "title": "bridge",
    "exact": true
  },
  {
    "path": "/test/counter",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__testPage__counter' */'@/pages/testPage/counter'), loading: LoadingComponent}),
    "title": "counter",
    "exact": true
  },
  {
    "path": "/test/styles",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__testPage__styles' */'@/pages/testPage/styles'), loading: LoadingComponent}),
    "title": "styles",
    "exact": true
  },
  {
    "path": "/housekeeper-commerce",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__HousekeeperCommerce' */'@/pages/externalPages/HousekeeperCommerce'), loading: LoadingComponent}),
    "title": "邻居商品",
    "meta": {
      "analytic": "housekeeper_commerce"
    },
    "exact": true
  },
  {
    "path": "/choose-project",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__ChooseProject' */'@/pages/externalPages/ChooseProject'), loading: LoadingComponent}),
    "title": "邻居商品",
    "exact": true
  },
  {
    "path": "/my-recommendation",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__MyRecommendation' */'@/pages/externalPages/MyRecommendation'), loading: LoadingComponent}),
    "title": "我的推荐",
    "exact": true
  },
  {
    "path": "/external-product-detail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__ExternalProductDetail' */'@/pages/externalPages/ExternalProductDetail'), loading: LoadingComponent}),
    "title": "友邻商品详情",
    "exact": true
  },
  {
    "path": "/blackpearl-product-detail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__BlackpearlProductDetail' */'@/pages/externalPages/BlackpearlProductDetail'), loading: LoadingComponent}),
    "title": "友邻商品详情",
    "meta": {
      "analytic": "blackpearl_product_detail"
    },
    "exact": true
  },
  {
    "path": "/neighbor-product-detail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__NeighborProductDetail' */'@/pages/externalPages/NeighborProductDetail'), loading: LoadingComponent}),
    "title": "便民商品详情",
    "meta": {
      "analytic": "neighbor_product_detail"
    },
    "exact": true
  },
  {
    "path": "/goods-external",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__externalPages__goodsExternal' */'@/pages/externalPages/goodsExternal'), loading: LoadingComponent}),
    "title": " ",
    "exact": true
  },
  {
    "path": "/zzr-market-tab",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__zzrMarketTab' */'@/pages/zzrMarketTab'), loading: LoadingComponent}),
    "title": "市集",
    "exact": true
  },
  {
    "path": "/zzr-good-service-tab",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__zzrGoodServiceTab' */'@/pages/zzrGoodServiceTab'), loading: LoadingComponent}),
    "title": "好服务",
    "meta": {
      "analytic": "zzr_good_service_tab"
    },
    "exact": true
  },
  {
    "path": "/home",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'@/pages/home'), loading: LoadingComponent}),
    "title": "友邻市集",
    "meta": {
      "analytic": "home"
    },
    "exact": true
  },
  {
    "path": "/home-with-back",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'@/pages/home'), loading: LoadingComponent}),
    "title": "友邻市集",
    "meta": {
      "analytic": "home"
    },
    "exact": true
  },
  {
    "path": "/speed",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__speed' */'@/pages/speed'), loading: LoadingComponent}),
    "title": "极速达",
    "exact": true
  },
  {
    "path": "/product-detail/:id",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productDetail' */'@/pages/productDetail'), loading: LoadingComponent}),
    "title": "商品详情",
    "meta": {
      "analytic": "product_detail"
    },
    "exact": true
  },
  {
    "path": "/seckill-detail/:id",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__seckillDetail' */'@/pages/seckillDetail'), loading: LoadingComponent}),
    "title": "商品秒杀",
    "exact": true
  },
  {
    "path": "/cart",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cart' */'@/pages/cart'), loading: LoadingComponent}),
    "title": "购物车",
    "meta": {
      "analytic": "cart"
    },
    "exact": true
  },
  {
    "path": "/atmosphere-details",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__atmosphereDetails' */'@/pages/atmosphereDetails'), loading: LoadingComponent}),
    "title": "氛围详情",
    "meta": {
      "analytic": "atmosphere_details"
    },
    "exact": true
  },
  {
    "path": "/order-details",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__orderDetails' */'@/pages/order/orderDetails'), loading: LoadingComponent}),
    "title": "订单详情",
    "exact": true
  },
  {
    "path": "/order-list",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__orderList' */'@/pages/order/orderList'), loading: LoadingComponent}),
    "title": "订单列表",
    "meta": {
      "analytic": "order_list"
    },
    "exact": true
  },
  {
    "path": "/milk-book",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__milkBook' */'@/pages/milkBook'), loading: LoadingComponent}),
    "title": " ",
    "meta": {
      "analytic": "milk_book"
    },
    "exact": true
  },
  {
    "path": "/confirm-order",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__confirmOrder' */'@/pages/order/confirmOrder'), loading: LoadingComponent}),
    "title": "确认订单",
    "meta": {
      "analytic": "confirm_order"
    },
    "exact": true
  },
  {
    "path": "/seckill-confirm",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__confirmOrder' */'@/pages/order/confirmOrder'), loading: LoadingComponent}),
    "title": "确认订单",
    "exact": true
  },
  {
    "path": "/choose-address",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chooseAddress' */'@/pages/chooseAddress'), loading: LoadingComponent}),
    "title": "选择收货地址",
    "exact": true
  },
  {
    "path": "/choose-zzr-project",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chooseZzrProject' */'@/pages/chooseZzrProject'), loading: LoadingComponent}),
    "title": "选择项目",
    "exact": true
  },
  {
    "path": "/edit-address",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__editAddress' */'@/pages/editAddress'), loading: LoadingComponent}),
    "title": "编辑收货地址",
    "exact": true
  },
  {
    "path": "/pause-delivery",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__pauseDelivery' */'@/pages/order/pauseDelivery'), loading: LoadingComponent}),
    "title": "暂停配送",
    "exact": true
  },
  {
    "path": "/after-sale",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__afterSale' */'@/pages/order/afterSale'), loading: LoadingComponent}),
    "title": "申请售后服务",
    "exact": true
  },
  {
    "path": "/applyAfterSaleServices/:orderId/:itemId/:afterSaleType/:logisticsType/:orderItemStatus",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__newAfterSale' */'@/pages/order/newAfterSale'), loading: LoadingComponent}),
    "title": "申请售后服务",
    "exact": true
  },
  {
    "path": "/afterSaleServiceType/:orderId/:itemId/:orderStatus/:logisticsType/:orderItemStatus",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__afterSaleType' */'@/pages/order/afterSaleType'), loading: LoadingComponent}),
    "title": "申请售后服务",
    "exact": true
  },
  {
    "path": "/afterSaleProgress/:orderId/:itemId",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__afterSaleProgress' */'@/pages/order/afterSaleProgress'), loading: LoadingComponent}),
    "title": "售后详情",
    "exact": true
  },
  {
    "path": "/afterSaleProgress/:orderId/:itemId/:logisticsType/:orderItemStatus",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__afterSaleProgress' */'@/pages/order/afterSaleProgress'), loading: LoadingComponent}),
    "title": "售后详情",
    "exact": true
  },
  {
    "path": "/expressBill/:orderId/:itemId/:afterServiceId",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__newExpressBill' */'@/pages/order/newExpressBill'), loading: LoadingComponent}),
    "title": "售后详情",
    "exact": true
  },
  {
    "path": "/after-sale-rules",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__afterSaleRules' */'@/pages/order/afterSaleRules'), loading: LoadingComponent}),
    "title": "退款说明",
    "exact": true
  },
  {
    "path": "/coupon-list",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__couponList' */'@/pages/order/couponList'), loading: LoadingComponent}),
    "title": "优惠券列表",
    "exact": true
  },
  {
    "path": "/pay-success",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__paySuccess' */'@/pages/order/paySuccess'), loading: LoadingComponent}),
    "title": "支付成功",
    "meta": {
      "analytic": "pay_success"
    },
    "exact": true
  },
  {
    "path": "/spring-festival",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__springFestival' */'@/pages/springFestival'), loading: LoadingComponent}),
    "title": "年货节",
    "exact": true
  },
  {
    "path": "/all-category",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__allCategory' */'@/pages/allCategory'), loading: LoadingComponent}),
    "title": "全部分类",
    "meta": {
      "analytic": "all_category"
    },
    "exact": true
  },
  {
    "path": "/category-goods",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__categoryGoods' */'@/pages/categoryGoods'), loading: LoadingComponent}),
    "title": "分类商品",
    "meta": {
      "analytic": "category_goods"
    },
    "exact": true
  },
  {
    "path": "/search",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__searchProduct' */'@/pages/searchProduct'), loading: LoadingComponent}),
    "title": "搜索",
    "meta": {
      "analytic": "search"
    },
    "exact": true
  },
  {
    "path": "/shine/plan/projectList",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__projectList' */'@/pages/projectList'), loading: LoadingComponent}),
    "title": "工程列表",
    "exact": true
  },
  {
    "path": "/shine/plan/projectList/detail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__projectList__details' */'@/pages/projectList/details'), loading: LoadingComponent}),
    "title": "项目详情",
    "exact": true
  },
  {
    "path": "/shine/plan/collectItems",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__projectList__collectItems' */'@/pages/projectList/collectItems'), loading: LoadingComponent}),
    "title": "项目详情",
    "exact": true
  },
  {
    "path": "/shine/plan/range",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__projectList__range' */'@/pages/projectList/range'), loading: LoadingComponent}),
    "title": "社区排名",
    "exact": true
  },
  {
    "path": "/supplier-detail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__supplierDetail' */'@/pages/supplierDetail'), loading: LoadingComponent}),
    "title": "店铺详情",
    "exact": true
  },
  {
    "path": "/supplier-info",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__supplierInfo' */'@/pages/supplierInfo'), loading: LoadingComponent}),
    "title": "店铺信息",
    "exact": true
  },
  {
    "path": "/complaint-supplier",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__complaintSupplier' */'@/pages/complaintSupplier'), loading: LoadingComponent}),
    "title": "投诉商家",
    "exact": true
  },
  {
    "path": "/buyer-info",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__buyerInfo' */'@/pages/order/buyerInfo'), loading: LoadingComponent}),
    "title": "已选客户信息",
    "exact": true
  },
  {
    "path": "/complaint-success",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__complaintSuccess' */'@/pages/complaintSuccess'), loading: LoadingComponent}),
    "title": "投诉成功",
    "exact": true
  },
  {
    "path": "/comment",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__addComment' */'@/pages/addComment'), loading: LoadingComponent}),
    "title": "点评一下",
    "exact": true
  },
  {
    "path": "/comment-detail",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__commentDetail' */'@/pages/commentDetail'), loading: LoadingComponent}),
    "title": "查看点评",
    "exact": true
  },
  {
    "path": "/wanrentuan",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wanrentuan' */'@/pages/wanrentuan'), loading: LoadingComponent}),
    "title": "万人团",
    "meta": {
      "analytic": "wanrentuan"
    },
    "exact": true
  },
  {
    "path": "/comment-list/:id",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__commentList' */'@/pages/commentList'), loading: LoadingComponent}),
    "title": "邻居点评",
    "exact": true
  },
  {
    "path": "/comment-success",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__commentSuccess' */'@/pages/commentSuccess'), loading: LoadingComponent}),
    "title": "点评成功",
    "exact": true
  },
  {
    "path": "/view-logistics",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__viewLogistics' */'@/pages/viewLogistics'), loading: LoadingComponent}),
    "title": "查看物流",
    "exact": true
  },
  {
    "path": "/ylplan",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ylPlan' */'@/pages/ylPlan'), loading: LoadingComponent}),
    "title": "友邻计划",
    "exact": true
  },
  {
    "path": "/plan-introduction",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__planIntroduction' */'@/pages/planIntroduction'), loading: LoadingComponent}),
    "title": "什么是友邻计划",
    "exact": true
  },
  {
    "path": "/plan-rules",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__communityRules' */'@/pages/communityRules'), loading: LoadingComponent}),
    "title": "共建美丽社区活动细则",
    "exact": true
  },
  {
    "path": "/customer-service",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customerService' */'@/pages/customerService'), loading: LoadingComponent}),
    "title": "客服",
    "exact": true
  },
  {
    "path": "/recommend-product",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__recommendProduct' */'@/pages/recommendProduct'), loading: LoadingComponent}),
    "title": "物业预缴发券",
    "meta": {
      "analytic": "recommend_product"
    },
    "exact": true
  },
  {
    "path": "/join-us",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__joinUs' */'@/pages/joinUs'), loading: LoadingComponent}),
    "title": "加入我们",
    "meta": {
      "analytic": "join_us"
    },
    "exact": true
  },
  {
    "path": "/activityTopic/:id",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activityTopic' */'@/pages/activityTopic'), loading: LoadingComponent}),
    "title": "专题页",
    "meta": {
      "analytic": "activity_topic"
    },
    "exact": true
  },
  {
    "path": "/discountTopic",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__discountTopic' */'@/pages/discountTopic'), loading: LoadingComponent}),
    "title": "超级秒杀日",
    "meta": {
      "analytic": "discount_topic"
    },
    "exact": true
  },
  {
    "path": "/customer-list/:id",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customerList' */'@/pages/customerList'), loading: LoadingComponent}),
    "title": "客户信息列表",
    "exact": true
  },
  {
    "path": "/customer-edit/:goodsId/:userId",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customerEdit' */'@/pages/customerEdit'), loading: LoadingComponent}),
    "title": "客户信息编辑",
    "exact": true
  },
  {
    "path": "/*",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'@/pages/home'), loading: LoadingComponent}),
    "title": "友邻市集",
    "meta": {
      "analytic": "home"
    },
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
